const CreatedInput = () => null;

export default CreatedInput;
